'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _types = require('./types');

var TYPES = _interopRequireWildcard(_types);

var _eventservice = require('./eventservice');

var _preloader = require('./preloader');

var _preloader2 = _interopRequireDefault(_preloader);

var _modal = require('./modal');

var _modal2 = _interopRequireDefault(_modal);

var _notice = require('./notice');

var _notice2 = _interopRequireDefault(_notice);

var _ok = require('./ok');

var _ok2 = _interopRequireDefault(_ok);

var _fail = require('./fail');

var _fail2 = _interopRequireDefault(_fail);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// 生成GUID字符串
function guid() {
    var r = function r() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    };
    return r() + r() + r() + '-' + r() + '_' + r() + '-' + r() + '_' + r() + r() + r();
}

var Layer = function (_Component) {
    _inherits(Layer, _Component);

    function Layer() {
        _classCallCheck(this, Layer);

        var _this = _possibleConstructorReturn(this, (Layer.__proto__ || Object.getPrototypeOf(Layer)).call(this));

        _this.state = {
            loading: false, // loading 状态
            notices: [],
            modals: [],
            oks: [],
            fails: []
        };
        return _this;
    }

    _createClass(Layer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            // 加载loading
            _eventservice.E.on(TYPES.SHOW_LOADING, function () {
                _this2.setState({ loading: true });
            });

            // 关闭loading
            _eventservice.E.on(TYPES.HIDE_LOADING, function () {
                _this2.setState({ loading: false });
            });

            // 打开alert
            _eventservice.E.on(TYPES.SHOW_ALERT, function (args) {
                var modals = _this2.state.modals;
                // 对象形式
                if ((typeof args === 'undefined' ? 'undefined' : _typeof(args)) === 'object') {
                    modals.push({
                        id: guid(),
                        title: args.title,
                        message: args.message,
                        image: args.image,
                        option: args.text ? [{
                            text: args.text,
                            fn: args.fn
                        }] : []
                    });
                } else {
                    // 普通形式
                    modals.push({
                        id: guid(),
                        title: '',
                        message: args,
                        option: []
                    });
                }
                _this2.setState({ loading: false, modals: modals });
            });

            _eventservice.E.on(TYPES.SHOW_CONFIRM, function (args) {
                var modals = _this2.state.modals;
                // 为每组数据添加一个guid
                args.id = guid();
                modals.push(args);
                _this2.setState({ loading: false, modals: modals });
            });

            _eventservice.E.on(TYPES.SHOW_NOTICE, function (args) {
                var notices = _this2.state.notices;
                // 为每组数据添加一个guid
                notices.push({
                    id: guid(),
                    duration: 2000,
                    message: args
                });
                _this2.setState({ loading: false, notices: notices });
            });

            _eventservice.E.on(TYPES.CLEAR, function () {
                return _this2.setState({
                    loading: false,
                    modals: []
                });
            });

            _eventservice.E.on(TYPES.SHOW_OK, function (args) {
                var oks = _this2.state.oks;
                // 为每组数据添加一个guid
                oks.push({
                    id: guid(),
                    duration: 2000,
                    message: args
                });
                _this2.setState({ loading: false, oks: oks });
            });

            _eventservice.E.on(TYPES.SHOW_FAIL, function (args) {
                var fails = _this2.state.fails;
                // 为每组数据添加一个guid
                fails.push({
                    id: guid(),
                    duration: 2000,
                    message: args
                });
                _this2.setState({ loading: false, fails: fails });
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            // 解绑事件
            _eventservice.E.clearAllEvents();
        }

        // 关闭指定的弹窗

    }, {
        key: 'closeModal',
        value: function closeModal(id) {
            var modals = this.state.modals.filter(function (item) {
                return item.id !== id;
            });
            this.setState({ modals: modals });
        }

        // 关闭指定的小提示

    }, {
        key: 'closeNotice',
        value: function closeNotice(id) {
            var notices = this.state.notices.filter(function (item) {
                return item.id !== id;
            });
            this.setState({ notices: notices });
        }
    }, {
        key: 'closeOk',
        value: function closeOk(id) {
            var oks = this.state.oks.filter(function (item) {
                return item.id !== id;
            });
            this.setState({ oks: oks });
        }
    }, {
        key: 'closeFail',
        value: function closeFail(id) {
            var fails = this.state.fails.filter(function (item) {
                return item.id !== id;
            });
            this.setState({ fails: fails });
        }
    }, {
        key: '_renderModal',
        value: function _renderModal() {
            var item = this.state.modals[0];
            if (!item) {
                return null;
            }
            return _react2.default.createElement(
                'div',
                { className: 'layer-root' },
                _react2.default.createElement(_modal2.default, {
                    id: item.id,
                    title: item.title,
                    message: item.message,
                    option: item.option,
                    image: item.image,
                    close: this.closeModal.bind(this)
                })
            );
        }
    }, {
        key: '_renderNotice',
        value: function _renderNotice() {
            var item = this.state.notices[0];
            if (!item) {
                return null;
            }
            return _react2.default.createElement(
                'div',
                { className: 'layer-notify-root' },
                _react2.default.createElement(_notice2.default, {
                    id: item.id,
                    close: this.closeNotice.bind(this),
                    duration: item.duration,
                    message: item.message })
            );
        }
    }, {
        key: '_renderOk',
        value: function _renderOk() {
            var item = this.state.oks[0];
            if (!item) {
                return null;
            }
            return _react2.default.createElement(
                'div',
                { className: 'okfail-root' },
                _react2.default.createElement(_ok2.default, {
                    id: item.id,
                    close: this.closeOk.bind(this),
                    duration: item.duration,
                    message: item.message })
            );
        }
    }, {
        key: '_renderFail',
        value: function _renderFail() {
            var item = this.state.fails[0];
            if (!item) {
                return null;
            }
            return _react2.default.createElement(
                'div',
                { className: 'okfail-root' },
                _react2.default.createElement(_fail2.default, {
                    id: item.id,
                    close: this.closeFail.bind(this),
                    duration: item.duration,
                    message: item.message })
            );
        }
    }, {
        key: '_renderPreloader',
        value: function _renderPreloader() {
            return _react2.default.createElement(
                'div',
                { className: 'layer-root' },
                _react2.default.createElement(_preloader2.default, null)
            );
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.state.modals.length > 0) {
                return this._renderModal();
            }
            if (this.state.notices.length > 0) {
                return this._renderNotice();
            }
            if (this.state.loading) {
                return this._renderPreloader();
            }
            if (this.state.oks.length > 0) {
                return this._renderOk();
            }
            if (this.state.fails.length > 0) {
                return this._renderFail();
            }
            return null;
        }
    }]);

    return Layer;
}(_react.Component);

exports.default = Layer;
module.exports = exports['default'];